<template>
  <div
    class="field-wrap"
    :class="{'field-wrap--has-prefix': prefix, 'field-wrap--has-suffix': suffix}"
  >
    <v-icon
      v-if="prefix"
      class="field-wrap__icon field-wrap__icon--prefix"
      :type="prefix"
    />
    <slot />
    <v-icon
      v-if="suffix"
      class="field-wrap__icon field-wrap__icon--suffix"
      :type="suffix"
    />
  </div>
</template>
<script>
import Icon from "@/atoms/Icon";
export default {
  components: {
    "v-icon": Icon,
  },
  props: {
    prefix: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
	@import "../../styles/shared/shared";
	.field-wrap {
		position: relative;
		width: 100%;
		&--has-prefix input {
			padding-left: ($input-padding * 2) + 1rem;
		}
		&--has-suffix input {
			padding-right: ($input-padding * 2) + 1rem;
		}
		&__icon {
			position: absolute;
			width: 1rem;
			height: 1rem;
			top: $input-padding;
		}
		&__icon--prefix {
			left: $input-padding;
		}
		&__icon--suffix {
			right: $input-padding;
		}
	}
</style>
